import React, { FC, ReactNode } from 'react'
import { useApiInstance } from 'src/hooks/api'
import { PresignedDownloadLink } from 'src/components/ui/link/presignedDownloadLink'

interface NetworkOutageDownloadLinkProps {
  outageId: number;
  children: ReactNode;
}

export const NetworkOutageDownloadLink: FC<NetworkOutageDownloadLinkProps> = ({ outageId, children }) => {
  const api = useApiInstance()

  return (
    <PresignedDownloadLink getUrl={() => api.v1AdminHardwareNetworkOutagesOutageIdDownloadLinkGet(outageId)}>
      {children}
    </PresignedDownloadLink>
  )
}
